<template>
  <el-container>
    <el-main style="padding: 0">
      <vm-table 
          ref="vmTable" 
          :filter.sync="filter" 
          module="basic" 
          url="workerGroups" 
          @select="select" 
          @select-all="select">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.editPage.open(0)"> 新建</el-button>
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除</el-button>
        </div>
        <template slot="adSearch">
          <vm-search label="班组编号：">
            <el-input v-model.trim="filter.groupNo" placeholder="请输入班组编号" clearable/>
          </vm-search>
          <vm-search label="班组名称：">
            <el-input v-model.trim="filter.groupName" placeholder="请输入班组名称" clearable/>
          </vm-search>
          <vm-search label="生产类型：">
            <el-select v-model="filter.groupType" clearable placeholder="请选择班组类型">
              <el-option v-for="(item, index) in groupTypeList" :key="index" :label="item.name" :value="item.code"/>
            </el-select>
          </vm-search>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="groupNo" align="center" label="班组编号" width="120"/>
        <el-table-column prop="groupName" align="left" show-overflow-tooltip label="班组名称"/>
        <el-table-column prop="groupLeaderName" align="left" show-overflow-tooltip label="班组长"/>
        <el-table-column prop="groupMemberName" align="left" show-overflow-tooltip label="班组成员"/>
        <el-table-column prop="groupTypeName" align="center" label="班组分类" width="120"/>
        <el-table-column prop="groupWorkCenterName" align="left" show-overflow-tooltip label="工作中心"/>
        <el-table-column prop="note" align="left" show-overflow-tooltip label="备注"/>
        <el-table-column prop="creatorName" align="center" label="创建人" width="120"/>
        <el-table-column prop="createTime" align="center" label="创建时间" width="150"/>
        <el-table-column 
            label="操作" 
            align="center" 
            width="120px" 
            prop="action" 
            fixed="right">
          <template v-slot="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkId)"> 编辑</el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row.pkId)"> 删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <worker-group-edit ref="editPage" :group-type-list="groupTypeList" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import WorkerGroupEdit from "@/views/information/WorkerGroup/WorkerGroupEdit";

  export default {
    name: "WorkerGroupList",
    components: { WorkerGroupEdit, VmTable, VmSearch },
    data() {
      return {
        addAuth: this.$auth(355),
        delAllAuth: this.$auth(364),
        editAuth: this.$auth(356),
        delAuth: this.$auth(357),
        selection: [],
        filter: {},
        groupTypeList: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getGroupTypeDict();
    },
    methods: {
      // 查询
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      select(selection) {
        this.selection = selection;
      },

      // 班组类型字典
      getGroupTypeDict() {
        this.$http.get("basic", "dictionaries/dictEnum/WorkerGroupType").then((resp) => {
          if (resp.success) {
            this.groupTypeList = resp.data;
          }
        });
      },

      // 单个删除
      deleteRow(pkId) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "workerGroups", pkId).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "workerGroups/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.getList(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>
